import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ImagesBlockItem from './ImagesBlockItem';
import GalleryApp from '../../../legacy/flux/components/GalleryApp.react';
import GalleryActionCreators from '../../../legacy/flux/actions/GalleryActionCreators';
import GalleryStore from '../../../legacy/flux/stores/GalleryStore';
import MemberStore from '../../../legacy/flux/stores/MemberStore';
import popup from '../../../legacy/app/popup';

class ImagesBlock extends React.Component {
  state = {
    images: GalleryStore.getMemberImages(this.props.memberId),
    member: MemberStore.get(this.props.memberId),
    galleryOpen: false,
    galleryRoot: false,
  };

  componentDidMount() {
    const { memberId } = this.props;
    if (!memberId) {
      return;
    }

    GalleryStore.addChangeListener(this.onChange);

    const { images } = this.state;
    if (!images) {
      GalleryStore.setLoad(true);
      GalleryActionCreators.galleryLoad(memberId);
    }
  }

  componentWillUnmount() {
    GalleryStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      images: GalleryStore.getMemberImages(this.props.memberId),
      member: MemberStore.get(this.props.memberId),
    });
  };

  onGalleryOpen = (e, gotoImage) => {
    e.preventDefault();

    const {
      memberId,
      myId,
      myImage,
      myStatus,
      needAbo,
      verificationRestrictions,
    } = this.props;

    //
    if (myId !== memberId) {
      //
      if (verificationRestrictions) {
        popup.profileVerificationMessage();
        return;
      }

      //
      if (myStatus === 'unverified') {
        popup.verificationMessage();
        return;
      }

      //
      if (!myImage) {
        popup.imageUpload('?show_no_image_popup=1');
        return;
      }

      //
      if (needAbo) {
        popup.subscriptionMessage();
        return;
      }
    }

    const galleryMemberId = GalleryStore.getMemberId();
    if (!galleryMemberId || galleryMemberId !== memberId) {
      const { images } = this.state;
      GalleryStore.setImages(images, gotoImage);
      GalleryStore.setMemberId(memberId);
    } else {
      GalleryStore.setCurrentByFilename(gotoImage);
    }

    //
    // this.setState({ galleryOpen: true });

    // To do it like this, is necessary because of iOS
    const galleryRoot = document.getElementById('gallery');
    if (!galleryRoot) {
      this.setState({
        galleryOpen: true,
        galleryRoot: false,
      });
      return;
    }

    ReactDOM.render(
      <GalleryApp
        onClose={this.onGalleryClose}
        showLikeButton
        showComplimentButton
      />,
      galleryRoot,
    );

    this.setState({
      galleryOpen: true,
      galleryRoot: true,
    });
    //
  };

  onGalleryClose = () => {
    // this.setState({ galleryOpen: false });

    // To do it like this, is necessary because of iOS
    const galleryRoot = document.getElementById('gallery');
    if (!galleryRoot) {
      this.setState({
        galleryOpen: false,
        galleryRoot: false,
      });
      return;
    }

    ReactDOM.unmountComponentAtNode(document.getElementById('gallery'));

    this.setState({
      galleryOpen: false,
      galleryRoot: true,
    });
    //
  };

  render() {
    const {
      images,
      member,
      galleryOpen,
      galleryRoot,
    } = this.state;

    if (!images) {
      return null;
    }

    const {
      memberId,
      hasMenu,
      menuType,
      imagesLimit,
    } = this.props;

    const items = [];

    images.slice(0, imagesLimit || images.size).forEach((image) => {
      items.push(
        <ImagesBlockItem
          key={image.file}
          filename={image.file}
          fileId={image.file_id}
          created={image.created}
          gcloud={image.gcloud}
          likes={image.likes}
          profile={image.profile}
          hasMenu={hasMenu}
          menuType={menuType}
          memberId={memberId}
          gender={member.sex}
          onGalleryOpen={this.onGalleryOpen}
        />,
      );
    });

    return (
      <div className="block imagesBlock">
        {items}
        {(galleryOpen && !galleryRoot) && (
          <GalleryApp
            onClose={this.onGalleryClose}
            showLikeButton
            showComplimentButton
          />
        )}
      </div>
    );
  }
}

ImagesBlock.propTypes = {
  memberId: PropTypes.string,
  hasMenu: PropTypes.bool,
  menuType: PropTypes.string,
  imagesLimit: PropTypes.number,
  myId: PropTypes.string,
  myImage: PropTypes.string,
  myStatus: PropTypes.string,
  needAbo: PropTypes.bool,
  verificationRestrictions: PropTypes.bool,
};

ImagesBlock.defaultProps = {
  memberId: '',
  hasMenu: false,
  menuType: '',
  imagesLimit: 0,
  myId: '',
  myImage: '',
  myStatus: '',
  needAbo: false,
  verificationRestrictions: false,
};

export default ImagesBlock;
